import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useFlag } from '../hooks/useFlag';
export const Flag = (_param)=>{
    var { condition , render , fallbackRender , component: Component , fallbackComponent: FallbackComponent , children  } = _param, props = _object_without_properties(_param, [
        "condition",
        "render",
        "fallbackRender",
        "component",
        "fallbackComponent",
        "children"
    ]);
    const isEnabled = useFlag(condition);
    if (isEnabled) {
        if (render) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, render());
        }
        if (Component) {
            return /*#__PURE__*/ React.createElement(Component, _extends({}, props), children);
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    if (fallbackRender) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, fallbackRender());
    }
    if (FallbackComponent) {
        return /*#__PURE__*/ React.createElement(FallbackComponent, _extends({}, props), children);
    }
    return null;
};
Flag.displayName = 'Flag';
export default Flag;
